import * as React from 'react';

export default class FixedNumber extends React.Component<any> {
    render() {
        let {value} = this.props;
        value = Number(value).toFixed(2);
        
        return <div> {value} </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/FixedNumber.tsx